import { makeStyles } from '@mui/styles';
const clickableCustomTooltipStyles = makeStyles(({ palette, typography }) => ({
    tooltipIconButton: {
        width: '15px',
        height: '15px',
        fontSize: typography.htmlFontSize,
        backgroundColor: palette.primary.main,
        color: palette.common.white,
        margin: '0 0 0 2px',
        padding: 0,
        '&:hover': {
            backgroundColor: palette.primary.main,
        },
    },
    tooltipSvgIconButton: {
        backgroundColor: palette.common.white,
        '&:hover': {
            backgroundColor: palette.common.white,
        },
    },
    tooltipSvg: {
        width: '18px',
        height: '18px',
    },
    tooltipArrow: {
        fontSize: typography.fontSize,
        width: 17,
        '&:before': {
            border: `1px solid ${palette.primary.main}`,
            backgroundColor: palette.common.white,
            boxSizing: 'border-box',
        },
        '&:after': {
            display: 'none',
        },
    },
    tooltipContainer: {
        position: 'relative',
        borderRadius: 10,
        fontSize: typography.fontSize,
        background: palette.common.white,
        color: palette.common.black,
        border: `1px solid ${palette.primary.main}`,
        margin: 0,
        padding: '15px 30px 20px 15px',
        boxShadow: '0 2px 5px rgba(0,0,50,0.2)',
        '& sup': {
            fontSize: typography.fontSize,
            verticalAlign: 'super',
        },
    },
}), { name: 'Common_ClickableCustomTooltip' });
export default clickableCustomTooltipStyles;
//# sourceMappingURL=clickableCustomTooltip.styles.js.map